import { Model } from "pinia-orm";
import { appVerboseName } from "@/utils/const";
import { BatchScenario, Examination, QuestionnaireSession } from "@/models";

export default class Scenario extends Model {
  static entity = "scenarios";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      duration: this.attr(0),
      name: this.string(""),
      complementaryName: this.string(""),
      isArchived: this.boolean(false),
      isPublished: this.boolean(false),
      isTimed: this.boolean(true),
      modifiedBy: this.string(""),
      servicesRelatedName: this.attr([appVerboseName.toLocaleLowerCase()]),
      examinationUuid: this.string(""),
      examinationData: this.belongsTo(Examination, "examinationUuid"),
      batchScenarios: this.hasMany(BatchScenario, "scenarioUuid"),
      questionnaireSessionsList: this.hasMany(QuestionnaireSession, "scenarioUuid"),
      scoreType: this.string("PERCENTAGE"),
      isDisplayed: this.boolean(true),
      extraData: this.attr({}),
    };
  }
  isDisabled() {
    return this.isPublished || this.isArchived;
  }
}
